import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img src="/brand/mark.png" alt="" aria-hidden="true" className={`${className} object-contain`} />
);

export const Logo = ({ testid = "nav-logo" }) => (
  <Link to="/" data-testid={testid} className="group flex shrink-0 items-center" aria-label="Perfect Digitals home">
    <img src="/brand/logo-white.png" alt="Perfect Digitals" className="h-10 w-auto shrink-0 transition-transform duration-500 group-hover:scale-[1.03] sm:h-12 lg:h-10 xl:h-12" />
  </Link>
);
